<template lang="pug">
  #appRelatoriosOuvidoria
    vue-progress-bar
    div(
      v-if="loader.status"
      v-loading="loader.status",
      :element-loading-text="loader.text",
      v-loading.fullscreen.lock="true"
    )
    header
      main-header(
        :notificacao="false"
        :hasListagemModelo="false"
      )
    main.container
      side-menu(:menuOptions="item")
      .content
        .container-router
          router-view
</template>

<script>
import { mapState } from 'vuex'
import { SideMenu } from 'sicarf-components'
import MainHeader from '@/components/MainHeader'

export default {
  name: 'Home',
  components: {
    SideMenu,
    MainHeader
  },
  data () {
    return {
      item: [
        {
          name: 'Relatórios Ouvidoria',
          icon: 'fal far fa-analytics',
          routeName: 'ouvidoriaRelatorios',
          routeGroup: 'OUVIDORIA_RELATORIOS'
        },
        {
          name: 'Listagem de Conversas',
          icon: 'fal far fa-comment-alt-lines',
          routeName: 'ouvidoriaConversas',
          routeGroup: 'OUVIDORIA_CONVERSAS'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      loader: state => state.loader
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

#appRelatoriosOuvidoria {
  width: 100%;
  height: 100%;

  /deep/ h1, h2, h3, h4, h5, p {
    color: #424242;
  }

  /deep/ main {
    height: calc(100vh - #{$header-size});
    width: 100%;
  }

  header {
    width: 100%;
    z-index: 5;
  }

  .container {
    display: flex;
    border-radius: 12px;
    width: 100%;
    min-height: 100%;
  }

  .content {
    width: 100%;
    padding: 20px 30px;
    overflow-y: scroll;
  }

  .container-router {
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    width: 100%;
    min-height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/Home.vue